import { useState } from "react";
import getAccessToken from "./getAccessToken";

const { REACT_APP_API_URL } = process.env;

export default function (key) {
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = getAccessToken();

  const start = async (params) => {
    try {
      setIsLoading(true);
      const url = `${REACT_APP_API_URL}${window._l(
        `/${key}/download?${new URLSearchParams(params).toString()}`
      )}`;
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${accessToken.value}`,
        },
      }).then((res) => res.text());
      window.open(response, "_blank");
    } catch (error) {
      // Bug real (auditoría 2026-08-14): catch vacío — a diferencia de
      // useUpload.js, una descarga fallida (red caída, 401, 500) no
      // avisaba nada; sólo se notaba porque no pasaba nada al clickear.
      window.notify({
        message: error?.message || "No pudimos descargar el archivo",
        type: "danger",
        title: "Error",
      });
    }
    setIsLoading(false);
  };

  return {
    isLoading,
    start,
  };
}
